import { DatePipe, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { localeInterceptor } from '@core/interceptors/locale.interceptor';
import { timeZoneInterceptor } from '@core/interceptors/time-zone.interceptor';
import { tokenInterceptor } from '@core/interceptors/token.interceptor';
import { unauthorizedInterceptor } from '@core/interceptors/unauthorized.interceptor';
import { provideLocaleConfig } from '@locale/locale-config.provider';
import { TranslocoRootModule } from '@locale/transloco-root.module';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { DateTimeTransformer } from '@shared/transformers/date-time-transformer';
import { DateTransformer } from '@shared/transformers/date-transformer';
import { provideTaiga, tuiButtonOptionsProvider, tuiHintOptionsProvider } from '@taiga-ui/core';
import { tuiInputDateOptionsProvider, tuiInputDateTimeOptionsProvider } from '@taiga-ui/kit';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export const appInsightsFactory = (): ApplicationInsights =>
  new ApplicationInsights({
    config: {
      instrumentationKey: environment.appInsights.instrumentationKey,
    },
  });

export const appConfig: ApplicationConfig = {
  providers: [
    tuiInputDateTimeOptionsProvider({
      valueTransformer: new DateTimeTransformer(),
    }),
    tuiInputDateOptionsProvider({
      valueTransformer: new DateTransformer(),
    }),
    tuiButtonOptionsProvider({
      size: 'm',
    }),
    tuiHintOptionsProvider({
      appearance: 'dark',
    }),
    provideTaiga({ mode: 'light' }),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withXhr(),
      withInterceptors([tokenInterceptor, unauthorizedInterceptor, timeZoneInterceptor, localeInterceptor]),
    ),
    provideRouter(routes),
    {
      provide: ApplicationInsights,
      useFactory: appInsightsFactory,
    },
    provideLocaleConfig(),
    importProvidersFrom(TranslocoRootModule),
    DatePipe,
    TitleCasePipe,
    UpperCasePipe,
  ],
};
